"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSeries = void 0;
var createMonotoneCubicInterpolator_1 = __importDefault(require("./createMonotoneCubicInterpolator"));
var util_1 = require("./util");
function convertSeries(series, domainPoints, adaptedYDomain, refsAreas, outlierSeries, hiddenRanges, yAtEndRanges) {
    var _a, _b;
    var outlierTickValue = getOutlierTickValue(adaptedYDomain);
    var refs = (refsAreas !== null && refsAreas !== void 0 ? refsAreas : []).flatMap(function (refsAreas) {
        return refsAreas.areaPercents.map(function (data, i) {
            var _a;
            return _a = {
                    x: data.x
                },
                _a[refsAreas.label.name] = data.percent,
                _a;
        });
    });
    var addTick = function (x) {
        if (typeof x === 'number')
            return (x + 1);
        if (x instanceof Date)
            return new Date(x.getTime() + 1);
        if (typeof x === 'object' && x !== null)
            return (+x + 1);
        return x;
    };
    var isHidden = function (x) {
        var _a;
        if (!hiddenRanges || !hiddenRanges.length)
            return false;
        var isStringDomain = typeof x === 'string';
        var isHiddenHandler = isStringDomain
            ? function (r) {
                var _a, _b, _c, _d, _e, _f;
                var iX = domainPoints.indexOf(x);
                var iInit = domainPoints.indexOf((_c = (_b = (_a = r.mask) === null || _a === void 0 ? void 0 : _a.hideDots) === null || _b === void 0 ? void 0 : _b.from) !== null && _c !== void 0 ? _c : r.init);
                var iEnd = domainPoints.indexOf((_f = (_e = (_d = r.mask) === null || _d === void 0 ? void 0 : _d.hideDots) === null || _e === void 0 ? void 0 : _e.to) !== null && _f !== void 0 ? _f : r.end);
                return iX >= iInit && iX < iEnd;
            }
            : function (r) { var _a, _b, _c, _d, _e; return +((_b = (_a = r.mask) === null || _a === void 0 ? void 0 : _a.hideDots.from) !== null && _b !== void 0 ? _b : r.init) <= +x && +x <= +((_e = (_d = (_c = r.mask) === null || _c === void 0 ? void 0 : _c.hideDots) === null || _d === void 0 ? void 0 : _d.to) !== null && _e !== void 0 ? _e : r.end); };
        return (_a = hiddenRanges === null || hiddenRanges === void 0 ? void 0 : hiddenRanges.some(isHiddenHandler)) !== null && _a !== void 0 ? _a : false;
    };
    var data = (_a = (_b = (series !== null && series !== void 0 ? series : [])
        .flatMap(function (serie, serieIndex) {
        return serie.data.map(function (data, dataIndex) {
            var _a;
            var _b, _c;
            var hasOutliers = outlierSeries && seriesHasOutliers(outlierSeries, serieIndex, dataIndex);
            var x = (_b = data.x) !== null && _b !== void 0 ? _b : domainPoints[dataIndex];
            var value = !isHidden(x)
                ? hasOutliers
                    ? getOutlierSeriesConfig(serie.name, data, outlierTickValue)
                    : (_a = {}, _a[serie.name] = util_1.getDataPointValue(data), _a)
                : {};
            return __assign({ x: (_c = data.x) !== null && _c !== void 0 ? _c : domainPoints[dataIndex] }, value);
        });
    })).concat.apply(_b, refs)).concat.apply(_a, (yAtEndRanges !== null && yAtEndRanges !== void 0 ? yAtEndRanges : []).map(function (r) { return (__assign({ x: addTick(r.end), hideDot: true }, series.reduce(function (acc, serie) {
        acc[serie.name] = r.mask.yAtEnd;
        return acc;
    }, {}))); })).sort(function (a, b) { return (a.x === b.x ? 0 : a.x > b.x ? 1 : -1); })
        .reduce(function (map, obj) {
        map.set(obj.x, __assign(__assign({}, map.get(obj.x)), obj));
        return map;
    }, new Map());
    /*
     * The values must be interpolated because Recharts considers empty values as 0
     * and the reference area crashes when there are X or Y points without a corresponding
     * reference area point.
     */
    var refValueNames = new Set(refs.flatMap(function (v) { return Object.keys(v); }));
    return interpolateValues(Array.from(data.values()), refValueNames);
}
exports.convertSeries = convertSeries;
var asNumber = function (x) { return (isNaN(+x) ? null : +x); };
function interpolateValues(orderedValues, valueNames) {
    valueNames.delete('x');
    var interpolators = getValuesInterpolators(orderedValues, valueNames);
    return orderedValues.map(function (v, i) {
        valueNames.forEach(function (vn) {
            var _a;
            if (!(vn in v))
                v[vn] = interpolators.get(vn)((_a = asNumber(v.x)) !== null && _a !== void 0 ? _a : i);
        });
        return v;
    });
}
function getValuesInterpolators(orderedValues, valueNames) {
    return Array.from(valueNames).reduce(function (interpolators, vn) {
        var valsWithVn = orderedValues.filter(function (v) { return vn in v; });
        var xs = valsWithVn.map(function (v, i) { var _a; return (_a = asNumber(v.x)) !== null && _a !== void 0 ? _a : i; });
        var ys = valsWithVn.map(function (v) { return v[vn]; });
        interpolators.set(vn, createMonotoneCubicInterpolator_1.default(xs, ys));
        return interpolators;
    }, new Map());
}
function getOutlierTickValue(adaptedYDomain) {
    var maxRange = util_1.getDomainMaxValue(adaptedYDomain);
    var outlierStep = util_1.getOutlierStepFromDomain(adaptedYDomain);
    var outlierTickValue = typeof maxRange === 'number'
        ? maxRange + outlierStep
        : maxRange instanceof Date
            ? new Date(maxRange.getTime() + outlierStep)
            : null;
    return outlierTickValue;
}
var seriesHasOutliers = function (outlierSeries, seriesIndex, dataIndex) { var _a; return !!((_a = outlierSeries[seriesIndex]) === null || _a === void 0 ? void 0 : _a.data[dataIndex]); };
var getOutlierSeriesConfig = function (seriesName, seriesData, outlierTickValue) {
    var _a;
    return _a = {},
        _a[seriesName] = outlierTickValue,
        _a[util_1.getOutlierSeriesName(seriesName)] = { value: util_1.getDataPointValue(seriesData), series: seriesName },
        _a;
};
//# sourceMappingURL=convertSeries.js.map